export const MODAL_MANAGER_SET_MODAL = (name, payload) => {
    return {
        type: 'MODAL_MANAGER_SET_MODAL',
        payload: {
            name: name || null,
            payload: payload || {},
        },
    }
}
